var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Appbar'),_c('Loading'),_c('Alert'),_c('Dialog'),_c('v-main',{staticClass:"MainColor"},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }